import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithoutAuth,
  headersWithAuthWithoutBody
} from "../APIHelpers/Responses";

export const userServices = {
  login,
  logout,
  userRegistration,
  forgotPassword,
  resetPassword,
  getUsers,
  getSingleUser,
  statusUpdateUser,

  changePassword,
  getCurrectLoginUser,

  updateProfile,
  updateUserProfile,
  sendEmailOTP,
  updateNewEmail,
};

async function login(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}login`,
    headersWithoutAuth("POST", userData)
  );
  const data = await response.json();
  handleResponse(data);
  if (data.statusCode === 200) {
    localStorage.setItem("token", JSON.stringify(data.token));
    window.location.href = "/home";
  }
  return data;
}

async function logout() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}logout`,
    headersWithAuth("PUT", {}, headers)
  );

  const data = await response.json();
  handleResponse(data);
  if (data?.statusCode === 200) {
    localStorage.clear();
    window.location.href = "/login";
  }
}

// User Registeration
async function userRegistration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}userRegistration`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Forgot Password
async function forgotPassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}forgotPassword`,
    headersWithoutAuth("PUT", userData)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Reset Password
async function resetPassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}resetPassword`,
    headersWithoutAuth("PUT", userData)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Get All Member
async function getUsers(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getUsers/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getUsers/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Member
async function getSingleUser(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleUser/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Current User Detail
async function getCurrectLoginUser() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCurrectLoginUser`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Status Update User
async function statusUpdateUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusUpdateUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Change Password
async function changePassword(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}changePassword`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update Profile
async function updateProfile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProfile`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Update User Profile
async function updateUserProfile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateUserProfile`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Send Email OTP
async function sendEmailOTP(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendEmailOTP`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Update New Email
async function updateNewEmail(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateNewEmail`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}